import { Component, Input, OnInit, Output,EventEmitter, ViewChild, AfterViewInit, ElementRef, HostListener } from '@angular/core';
import { NicaMaster } from '../nica-master-component/nica-master.component';
import { ContentObserver } from '@angular/cdk/observers';
import { ToolbarComponent } from '../toolbar/toolbar.component';

@Component({
  selector: 'app-nica-wrapper',
  templateUrl: './nica-wrapper.component.html',
  styleUrls: ['./nica-wrapper.component.css','../nica-master-component/nica-master.component.css','../../views/ana-soggetto/ana-soggetto.component.css']
})
export class NicaWrapperComponent  implements OnInit, AfterViewInit {

  @ViewChild('toolbar', {static:false} ) toolbar:ToolbarComponent
  @ViewChild('wrapanaToolbar', {static:false} ) wrapanaToolbar:ElementRef

  @Output() emettiChiusura : EventEmitter<any> = new EventEmitter<any>();
  @Output() emitToolbarLeft : EventEmitter<any> = new EventEmitter<any>();
  

  
  @Input() showBreadcrumb : boolean;
  @Input() caption : string;
  @Input() helpDoc : string;
  @Input() breadcrumbCaption : string;
  @Input() breadcrumbGroup : any;
  @Input() breadcrumbNavigation : any;
  @Input() isClosable : boolean;
  @Input() currentTemplate : any;
  @Input() footerVisible : boolean = true;
  @Input() isPopUp : boolean = false;

  @Input() showToolBar : boolean = true;
  @Input() backgroundToolbar : string;
  @Input() textColorToolbar : string;
  @Input() buttonToolbarUp : any[] = [];
  @Input() buttonToolbarBottom : any[] = [];
  @Input() customButtonToolbarBottom : any[] = [];
  @Input() customButtonToolbarTop : any[] = [];
  @Input() isOpen : boolean;
  @Input() id : string = '';
  @Input() InAttesaOpen :boolean = false;
  @Input() customizationClass:string = ''

  public timeInterval : NodeJS.Timer;

 

  constructor() {
    
  }


  @HostListener('document:click', ['$event'])
  gestisciClickEsterno(event: MouseEvent): void {
    if (!this.isOpen || !this.wrapanaToolbar) return;
      const cliccatoDentro = this.wrapanaToolbar.nativeElement.contains(event.target);
      this.isOpen = cliccatoDentro;
  }

  ngOnInit(): void {
    console.log('isPopUp inizializzato come:', this.isPopUp);

    if(typeof this.id == 'undefined'){
      this.id = ''
    }

  }
  ngAfterViewInit(){
    //id='ng-content'
    let popupHeight=$(".popupOvverlay .dx-overlay-content").height();
    
    //alert($(".popupOvverlay .dx-overlay-content").height())

    //this.toolbar.disegna()

   // alert(this.helpDoc)
  }
  


  onCrocettaClick(evt){

   

    console.log('onCrocettaClick--->',evt)

      if(evt=='closeToolbar'){

        //this.isOpen = ( this.isOpen== false ) ? true : false;

        if(!this.isOpen)
          this.openToolBar();
        
        else
          this.closeToolBar();
          
        //console.warn(this.buttonToolbarBottom,this.buttonToolbarUp);



      }
      else
        this.emettiChiusura.emit(evt);

  }



  openToolBar(event?) {
    if (typeof event != 'undefined') {
      event.preventDefault();
      event.stopPropagation();
    }

    this.InAttesaOpen = true;
    this.timeInterval = setTimeout(() => {
      if (!this.isOpen && this.InAttesaOpen)

        this.isOpen = true
    }, 100);



  }
  closeToolBar(event?) {

    if (typeof event != 'undefined') {
      event.preventDefault();
      event.stopPropagation();
    }
    this.InAttesaOpen = false;
    clearTimeout(this.timeInterval);
    setTimeout(() => {
      if (this.isOpen)
        this.isOpen = false

    }, 100);


  }

  buttonToolbarLeft(event){
    
    this.emitToolbarLeft.emit(event)

  }
}
